import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/anab_logo_white.png'


const _hoisted_1 = {
  id: "login",
  class: "w-full h-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed anabLogo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "fixed anabTeaserText" }
const _hoisted_4 = { class: "subline" }
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "loginSidebar" }, null, -1)

import {/*computed, */onMounted, /*reactive, */ref} from 'vue';
import {useGlobalStore} from "@/stores/GlobalStore";
//import router from "@/router";
import {useRoute} from "vue-router";
//import {notify} from "@kyvg/vue3-notification";
//import jwt_decode from "jwt-decode";
import {DisdiStateType, ErrorLocationType, /*NotifyType, PreferenceType, */SsoType} from "@/utilities/enums/Enums";
//import TabsWrapper from '@/components/tabs/TabsWrapper.vue';
//import TabItem from '@/components/tabs/TabItem.vue';
//import {email, helpers, minLength, required, sameAs} from '@vuelidate/validators';
//import useVuelidate from '@vuelidate/core';
//import {useI18n} from 'vue-i18n';
//import Error from "@/components/Error";
//import ErrorHandler from "@/utilities/helpers/ErrorHandler";
//import {GeneralResponse} from "@/models/api/Responses";
//import {i18n} from "@/utilities/i18n/config";
//import {UserPreference} from "@/models/user/UserPreference";
import {MiscService} from "@/utilities/services/entities/MiscService";
//import {AccountService} from "@/utilities/services/entities/AccountService";
//import {UserService} from "@/utilities/services/entities/UserService";
//import TextOrSpinner from "@/components/TextOrSpinner";
import {SystemCompanySettings} from "@/models/SystemCompanySettings";
//import {PermissionService} from "@/utilities/services/PermissionService";
//import {anabPolicies} from "@/AppConfig";
//import {usePermissionStore} from "@/stores/PermissionStore";
import OAuthService from "@/utilities/services/OAuthService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {anabClientConfig} from "@/AppConfig";


//const { t } = useI18n();

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const miscService = new MiscService();
//const accountService = new AccountService();
//const userService = new UserService();
//const permissionService = new PermissionService();

const globalStore = useGlobalStore();
//const error = ref(false);
const loading = ref(false);
let activeTab = ref(0);

let token = ref(useRoute().query.token);
let mail = ref(useRoute().query.email);
let returnUrl = ref(useRoute().query.returnUrl);
let viewName = ref(useRoute().query.viewName);
// let samlBackdoor = ref(useRoute().query.saml);
//let passwordResetMailSent = ref(false);

//const saveNewPassword = async () => {
//  loading.value = true;

//  const isFormCorrect = await vPassword$.value.$validate()
//  if (!isFormCorrect) {
//    // VALIDATOR ERROR
//    loading.value = false;
//    return
//  }

//  const resp = await accountService.resetPassword(token.value, mail.value, passwordForm.newPassword, passwordForm.newPasswordRepeat);

//  if(resp?.statusCode !== 0) return;

//  loading.value = false;

//  notify({
//    title: "Erfolg",
//    text: t('notifications.passwordReset'),
//    duration: -1,
//    type: NotifyType[NotifyType.success]
//  });

//  // move back to default tab
//  await router.replace("/login");
//  activeTab.value = 0;
//}

//const abortPasswordChange = () => {
//  token.value = undefined;
//  mail.value = undefined;

//  router.replace("/login");
//  activeTab.value = 0;
//}

async function saveSettings() {
    const startupConfig = await miscService.getStartupConfig(ErrorLocationType.login);
    if (startupConfig === null) {
        loading.value = false;
        return;
    }

    globalStore.settings.defaultHiddenColumns = startupConfig.preferenceInfo;
    globalStore.settings.systemCompanySettings = new SystemCompanySettings(startupConfig.companyName, startupConfig.companyIdCode);
    globalStore.settings.startupConfig = startupConfig.startupInfo;
    globalStore.settings.activitySettings = startupConfig.activityInfo;
    
    if (startupConfig.disdiInfo) {
        globalStore.settings.disdiSettings = startupConfig.disdiInfo;
        globalStore.settings.disdiSettings.disdi = DisdiStateType[startupConfig.disdiInfo.disdi as unknown as keyof typeof DisdiStateType];
    }
    
    globalStore.settings.enabledFeatures = startupConfig.enabledFeatures;
    globalStore.settings.automaticUnregister = startupConfig.automaticUnregister;
}

function generateRandomCodeVerifier(length = 128) {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, (byte) => charset[byte % charset.length]).join('');
}

async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    const base64url = btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return base64url;
}

async function samlLogin() {
    const idsUrl = globalStore.settings.startupConfig?.idsUrl;
    const clientId = anabClientConfig.clientId;
    const codeVerifier = generateRandomCodeVerifier();
    globalStore.codeVerifier = codeVerifier;
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    const authorizeUrl = "/connect/authorize?" +
        "client_id=" + clientId +
        "&redirect_uri=" + window.location.origin + "/sso/oAuthCallback" +
        "&response_type=code" +
        "&scope=" + anabClientConfig.scopes +
        "&state=44E2375F-300E-4D3F-86A8-D849BEA2F1AC" +
        "&code_challenge=" + codeChallenge +
        "&code_challenge_method=S256";

    const samlLoginUrl = idsUrl.replace(/\/$/, '') + "/saml/login?redirectUrl=" + encodeURIComponent(authorizeUrl);

    window.location.replace(samlLoginUrl);
}

async function oAuthLogin(viewName: string | null) {
    const metaDataUrl = globalStore.settings.startupConfig?.metaDataUrl;
    const metaData = !NullOrUndefinedHelper(metaDataUrl) ? await miscService.getOidcMetaData(metaDataUrl as string) : undefined;
    const oAuthService = new OAuthService(metaData);    
    if (NullOrUndefinedHelper(viewName)) {
        await oAuthService.login();
    }
    else {
        await oAuthService.loginByCustomView(viewName);
    }    
}

onMounted (async ()=>{
  globalStore.oAuth.routeAfterLogin = returnUrl.value || null;

  if(token.value !== undefined && mail.value !== undefined) {
    activeTab.value = 1;
  }

  try{
    loading.value = true;

    await saveSettings();

    if (globalStore.settings.startupConfig.ssoType == SsoType.saml) {
      await samlLogin();
    }
    else if (globalStore.settings.startupConfig.ssoType == SsoType.oauth) {
      await oAuthLogin(viewName.value || null);
    }
        
  }
  catch (e) {
    console.log("CONFIG LOADING FAILED!", e);
  }

  loading.value = false;
})


//const passwordForm = reactive({
//  newPassword: '',
//  newPasswordRepeat: '',
//})
//const passwordResetForm = reactive({
//  emailreset: '',
//})
//const form = reactive({
//  username: '',
//  password: '',
//  rememberMe: false
//});

//const rules = {
//  username: {
//    required: helpers.withMessage(t('validators.required'), required),
//    email: helpers.withMessage(t('validators.email'), email),
//  },
//  password: {
//    required: helpers.withMessage(t('validators.required'), required),
//  },
//}

//const passwordResetRules = {
//  emailreset: {
//    required: helpers.withMessage(t('validators.required'), required),
//    email: helpers.withMessage(t('validators.email'), email),
//  },
//}
//const newPasswordRules = computed(() => {

//  const hasNoneAlphaNum = helpers.regex(/\W/);
//  const hasNumber = helpers.regex(/\d/);
//  const hasUppercaseLetter = helpers.regex(/[A-Z]/);
//  const hasLowercaseLetter = helpers.regex(/[a-z]/);

//  const rules = {
//    newPassword: {
//      required: helpers.withMessage(t('validators.required'), required),
//      minLength: helpers.withMessage(t('validators.minLength', {amount: 8}), minLength(8)),
//      hasNoneAlphaNum: helpers.withMessage(t('validators.hasNoneAlphaNum'), hasNoneAlphaNum),
//      hasNumber: helpers.withMessage(t('validators.hasNumber'), hasNumber),
//      hasUppercaseLetter: helpers.withMessage(t('validators.hasUppercaseLetter'), hasUppercaseLetter),
//      hasLowercaseLetter: helpers.withMessage(t('validators.hasLowercaseLetter'), hasLowercaseLetter),
//    },
//    newPasswordRepeat: {
//      required: helpers.withMessage(t('validators.required'), required),
//      sameAsPassword: helpers.withMessage(t('validators.sameAs'), sameAs(passwordForm.newPassword)),
//    },
//  }
//  return rules
//})

//const v$ = useVuelidate(rules, form)
//const vPassword$ = useVuelidate(newPasswordRules, passwordForm)
//const vPasswordReset$ = useVuelidate(passwordResetRules, passwordResetForm)

//const sendPasswordResetMail = async () => {

//  loading.value = true;
//  const isFormCorrect = await vPasswordReset$.value.$validate()
//  if (!isFormCorrect) {
//    // VALIDATOR ERROR
//    loading.value = false;
//    return
//  }

//  const resp = await accountService.sendResetPasswordMail(passwordResetForm.emailreset, `${window.location.origin}/login`);

//  // sending failed
//  if(resp === null || resp === undefined || resp?.statusCode !== 0) {
//    loading.value = false;
//    return;
//  }

//  passwordResetMailSent.value = true;
//  loading.value = false;
//}

//const addDynamicRoles= async ()=>{
//  const readRoleString = globalStore.settings.disdiSettings?.permissionRead.join(", ");
//  const editRoleString = globalStore.settings.disdiSettings?.permissionEdit.join(", ");

//  //TODO magic string? better idea?
//  permissionService.updateDynamicPolicy("Disdi.Read", readRoleString as string);
//  permissionService.updateDynamicPolicy("Disdi.LocationPropertyEdit", editRoleString as string);
//}

//const onSubmit = async () => {
//  loading.value = true;
//  const isFormCorrect = await v$.value.$validate();

//  if (!isFormCorrect) {
//    // VALIDATOR ERROR
//    loading.value = false;
//    return
//  }

//  try{
//    const resp = await accountService.login(form.username, form.password, form.rememberMe);

//    if(resp === null || resp === undefined || resp.statusCode !== 0){
//      ErrorHandler.handleError(resp, ErrorLocationType.login);

//      loading.value = false;

//      return;
//    }

//    globalStore.setToken(resp.token);

//    const user = await userService.getIdsUserById(jwt_decode(resp.token).id, ErrorLocationType.login);

//    if(NullOrUndefinedHelper(user)){
//      loading.value = false;
//      return;
//    }

//    globalStore.setUser(user);

//    // get filters for user
//    const filterResp = await userService.getUserPreferences(user.id, PreferenceType.filter);
//    // get hiddenColumns for User
//    const columnResp = await userService.getUserPreferences(user.id, PreferenceType.hiddenColumn);
//    // get general settings for User
//    const genSetResp = await userService.getUserPreferences(user.id, PreferenceType.general);
//    // get columnOrder settings for User
//    const colOrderResp = await userService.getUserPreferences(user.id, PreferenceType.columnOrder);

//    if(filterResp?.statusCode === 0 && columnResp?.statusCode === 0 && genSetResp?.statusCode === 0 && colOrderResp?.statusCode === 0) {
//      globalStore.setUserPreferences({
//        userFilters: filterResp.preferenceInfo ?? [],
//        userHiddenColumns: columnResp.preferenceInfo ?? [],
//        userColumnOrder: colOrderResp.preferenceInfo ?? [],
//        general: {
//          darkMode: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "darkMode")?.attributeValue ?? false,
//          userStartPage: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "userStartPage")?.attributeValue ?? "/account",
//          userLocale: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "userLocale")?.attributeValue ?? "de",
//        },
//      });

//      // set language. if not null or undefined fallback to DE
//      // @ts-expect-error
//      i18n.global.locale.value = globalStore.userPreferences.general.userLocale;
//    }
//    else{
//      ErrorHandler.handleError(new GeneralResponse(6666, "Ihre Einstellungen konnten nicht geladen werden"), ErrorLocationType.table);

//      loading.value = false;
//    }

//    const notifResp = await miscService.getHubNotifications();

//    if(notifResp?.statusCode === 0){
//      globalStore.notifications = notifResp.notifications;
//    }
//    else{
//      ErrorHandler.handleError(new GeneralResponse(6667, "Die Benachrichtigungen konnte nicht geladen werden"), ErrorLocationType.table);

//      loading.value = false;
//    }

//    // set new fully set policy array on permission store to make sure it survives page reloads
//    const permissionStore = usePermissionStore();
//    permissionStore.anabPolicies = anabPolicies;

//    await addDynamicRoles();

//    // @ts-expect-error
//    await router.push(globalStore.userPreferences.general.userStartPage);

//    notify({
//      title: "Erfolg",
//      text: t('login.notifySuccessfulLogin'),
//      duration: 5000,
//      type: "success"
//    });

//    loading.value = false;
//  }
//  catch (e){
//    console.log(e);
//  }
//};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('login.subline')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('login.headline')
          }, null, 8, _hoisted_6)
        ])
      ])
    ]),
    _hoisted_7
  ]))
}
}

})